import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {ZadApiError} from '../zad/errors'
import {
  fetchZadProductReplenishment,
  fetchZadReplenishment,
  updateZadProductReplenishment,
} from './service'
import {
  FetchZadProductReplenishmentResponse,
  FetchZadReplenishmentResponse,
  ZadReplenishmentState,
} from './types'

const initialState: ZadReplenishmentState = {
  items: [],
  total: 0,
  totalPages: 0,
  summary: null,
  listLoading: false,
  listInitialized: false,
  error: null,
  errorCode: null,
  errorStatus: null,
  detail: null,
  detailLoading: false,
  detailError: null,
  actionLoading: false,
}

function applyListRejected(state: ZadReplenishmentState, action: PayloadAction<any>) {
  const payload = (action.payload || {}) as ZadApiError
  state.error = payload.error || 'Request failed'
  state.errorCode = payload.errorCode || null
  state.errorStatus = payload.status || null
  state.summary = null
}

const zadReplenishmentSlice = createSlice({
  name: 'zadReplenishment',
  initialState,
  reducers: {
    clearZadReplenishmentDetail: (state: ZadReplenishmentState) => {
      state.detail = null
      state.detailError = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchZadReplenishment.pending, (state: ZadReplenishmentState) => {
      state.listLoading = true
      state.error = null
      state.errorCode = null
      state.errorStatus = null
    })
    builder.addCase(
      fetchZadReplenishment.rejected,
      (state: ZadReplenishmentState, action: PayloadAction<any>) => {
        applyListRejected(state, action)
        state.listLoading = false
        state.listInitialized = true
        state.items = []
      }
    )
    builder.addCase(
      fetchZadReplenishment.fulfilled,
      (state: ZadReplenishmentState, action: PayloadAction<FetchZadReplenishmentResponse>) => {
        state.listLoading = false
        state.listInitialized = true
        state.error = null
        state.errorCode = null
        state.errorStatus = null
        state.items = action.payload.items
        state.total = action.payload.total
        state.totalPages = action.payload.totalPages
        state.summary = action.payload.summary
      }
    )

    builder.addCase(fetchZadProductReplenishment.pending, (state: ZadReplenishmentState) => {
      state.detailLoading = true
      state.detailError = null
    })
    builder.addCase(fetchZadProductReplenishment.rejected, (state: ZadReplenishmentState, action) => {
      const payload = (action.payload || {}) as ZadApiError
      state.detailLoading = false
      state.detail = null
      state.detailError = payload.error || 'Request failed'
    })
    builder.addCase(
      fetchZadProductReplenishment.fulfilled,
      (state: ZadReplenishmentState, action: PayloadAction<FetchZadProductReplenishmentResponse>) => {
        state.detailLoading = false
        state.detailError = null
        state.detail = action.payload.detail
      }
    )

    builder.addCase(updateZadProductReplenishment.pending, (state: ZadReplenishmentState) => {
      state.actionLoading = true
    })
    builder.addCase(updateZadProductReplenishment.rejected, (state: ZadReplenishmentState) => {
      state.actionLoading = false
    })
    builder.addCase(updateZadProductReplenishment.fulfilled, (state: ZadReplenishmentState) => {
      state.actionLoading = false
    })
  },
})

export default zadReplenishmentSlice.reducer
export const actions = zadReplenishmentSlice.actions
export {initialState as zadReplenishmentInitialState}
